
export const SET_BUCKET_DOMAIN = 'SET_BUCKET_DOMAIN'
export const SET_BUCKET_DOMAIN_TOKEN = 'SET_BUCKET_DOMAIN_TOKEN'
export const SET_ARTICLE_LABEL = 'update_article_label'